import { ResponsiveImageType, TitleMetaLinkTag } from "react-datocms";
import { FooterNavColumnRecord, LinkRecord, NavFlyoutGroupRecord } from "./navigation";
import { ButtonRecord, ISocialLink } from "./general";
import { SiteLocale } from "@graphql/types/graphql";

export interface ILocaleValue {
  locale: SiteLocale;
  value: string;
}

export interface IStaticPath {
  params: {
    slug: string | string[];
  };
  locale: string;
}

export interface IResponsiveImage {
  id: string;
  responsiveImage: ResponsiveImageType;
}

/*
 * Different models types
 */
export enum ModelTypes {
  HomepageRecord = "HomepageRecord",
  ArticleRecord = "ArticleRecord",
  ArticlesOverviewRecord = "ArticlesOverviewRecord",
  AuthorRecord = "AuthorRecord",
  ReviewerRecord = "ReviewerRecord",
  OfficeRecord = "OfficeRecord",
  ServiceRecord = "ServiceRecord",
  ServicesOverviewRecord = "ServicesOverviewRecord",
  ExpertiseRecord = "ExpertiseRecord",
  ExpertisesOverviewRecord = "ExpertisesOverviewRecord",
  NearbyOverviewRecord = "NearbyOverviewRecord",
  MunicipalityRecord = "MunicipalityRecord",
  PageRecord = "PageRecord",
  CareerRecord = "CareerRecord",
  JobListingOverviewRecord = "JobListingOverviewRecord",
  JobListingLayoutRecord = "JobListingLayoutRecord",
  ContactRecord = "ContactRecord",
  TaxesOverviewRecord = "TaxesOverviewRecord",
  AuditPageRecord = "AuditPageRecord",
  AccountanciesOverviewRecord = "AccountanciesOverviewRecord",
  SearchRecord = "SearchRecord",
  TargetGroupRecord = "TargetGroupRecord",
  ForWhoOverviewRecord = "ForWhoOverviewRecord",
}

/*
 * DatoCMS site meta data to generate meta tags
 */
export interface IDatoSiteMeta {
  faviconMetaTags?: TitleMetaLinkTag[];
}

/*
 * Site-wide shared data
 */
export interface IDatoGeneralMeta {
  logo: IResponsiveImage;
  site: IDatoSiteMeta;
  servicesTitle: string;
  servicesIntro: string;
  expertisesTitle: string;
  expertisesIntro: string;
  careerTitle: string;
  careerIntro: string;
  jobsTitle: string;
  jobsIntro: string;
  accountancyTitle: string;
  accountancyIntro: string;
  taxTitle: string;
  taxIntro: string;
  doormatImage: IResponsiveImage | null;
  footerIntro: string;
  expertises: any[]; // Changed from ExpertiseRecord[] to any[] as ExpertiseRecord is removed
  vat: string;
  email: string;
  address: string;
  addressStreet: string;
  addressCity: string;
  addressPostcode: string;
  addressCountry: string;
  phone?: string | null;
  geoMidpoint: { latitude: number; longitude: number };
  preview?: boolean;
  footerOverrides?: {
    intro?: string;
    logo?: IResponsiveImage;
    secondaryLogo?: IResponsiveImage;
    vat?: string;
    extraLinks?: any[];
    termsConditions?: any;
    privacyPolicy?: any;
    cookiePolicy?: any;
    kmoRegistrationNumbers?: string;
    socialLinks?: ISocialLink[];
  };
  newsletterOverrides?: {
    officeName?: string;
    hubspotNewsletterSegment?: string;
  };
  hubspotGeneralSegment?: string;
  socialLinks?: ISocialLink[];
  newsletterSuccessPage?: ButtonRecord;
  newsletterErrorPage?: ButtonRecord;
  secondaryNavigation?: LinkRecord[];
  mainNavigation?: (NavFlyoutGroupRecord | LinkRecord)[];
  navCta?: ButtonRecord;
  footerNav?: FooterNavColumnRecord[];
  taxes?: any[];
  subfooterNav?: LinkRecord[];
  accountancies: any[];
}

export interface IDatoPageSettings {
  enableDoormat: boolean;
}

export interface PageData<T> {
  general: IDatoGeneralMeta;
  fields: T;
}
